export const UPDATE_PROCESS_STATEMENT_COMMENT_VISIBILITY_FAILURE = 'UPDATE_PROCESS_STATEMENT_COMMENT_VISIBILITY_FAILURE';

export const updateProcessStatementCommentVisibilityFailure = error => ({
    type: UPDATE_PROCESS_STATEMENT_COMMENT_VISIBILITY_FAILURE,
    payload: error,
    error: true,
});
